import React from 'react'
import type { BadgeProps as MuiBadgeProps } from '@material-ui/core/Badge'
import MuiBadge from '@material-ui/core/Badge'

export type BadgeProps = MuiBadgeProps

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(function Badge(props, ref) {
  return <MuiBadge ref={ref} {...props} />
})

export default Badge
